module.exports = __webpack_public_path__ + "static/media/CharlesThomas01.d5421181.jpg";